<template>
  <section class="app-main">
    <div
      class="hamburger-container"
    >
      <Hamburger
        v-if="!sidebar.opened"
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggle-click="toggleSideBar"
      />
    </div>
    <Transition
      name="fade-transform"
      mode="out-in"
    >
      <RouterView />
    </Transition>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Hamburger from '@/components/Hamburger/index.vue'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'AppMain',
  components: { Hamburger }
})
export default class extends Vue {
  get sidebar() {
    return AppModule.sidebar
  }

  toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }
}
</script>

<style lang="scss" scoped>
$sidebar-bg-color: #f8f9fa;
$navbar-height: 60px; /* Height of the navbar */

.app-main {
  overflow: hidden;
  display: flex;
  flex-direction: row;
}

.hamburger-container {
  background-color: $sidebar-bg-color;
  width: 40px;
  height: calc(100vh - $navbar-height);
  padding: 4px 4px;
  display: flex;
  justify-content: center;
}
</style>
